import { BeatLoader } from 'react-spinners';
import './PrimaryButton.css';

const PrimaryButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  icon: IconComponent = null, 
  loading = false 
}) => {
  return (
    <button 
      className={`primary-button ${loading ? 'loading' : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <BeatLoader color='#fff' size={8} />
      ) : (
        <>
          {IconComponent && <span className="button-icon"><IconComponent /></span>}
          {children}
        </>
      )}
    </button>
  );
};

export default PrimaryButton;
